import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronRight } from "lucide-react";

/**
 * Il percorso per esteso in cima a una pagina di dettaglio.
 *
 * «Torna a Attrezzature» riportava sempre in cima all'elenco, e chi stava
 * lavorando su una categoria - gli strumenti di collaudo, gli autocarri -
 * doveva riaprirla ogni volta. Qui ogni passo e' un collegamento: si torna al
 * livello che serve, non all'inizio.
 *
 * L'ultimo passo e' la pagina che si sta guardando e non si clicca. La
 * freccia a sinistra porta al livello immediatamente superiore, che e' il
 * gesto di prima e resta il piu' usato.
 *
 * Le voci arrivano cosi':
 *   [{ testo: "Mezzi e attrezzature", a: "/attrezzature" },
 *    { testo: "Strumenti di collaudo", a: "/attrezzature?categoria=..." },
 *    { testo: "Colonnina SGM01" }]
 */
export default function Briciole({ voci = [], prova }) {
  const passi = voci.filter(Boolean);
  if (passi.length === 0) return null;
  // Il livello sopra: l'ultima voce che ha un indirizzo, saltando quella in
  // cui ci si trova.
  const sopra = [...passi.slice(0, -1)].reverse().find((v) => v.a);

  return (
    <nav className="flex items-center gap-1 flex-wrap text-sm" data-testid={prova || "briciole"}>
      {sopra && (
        <Link to={sopra.a} title={`Torna a ${sopra.testo}`}
              className="text-orange-600 hover:underline inline-flex items-center mr-1">
          <ArrowLeft className="w-4 h-4" />
        </Link>
      )}
      {passi.map((v, i) => {
        const ultima = i === passi.length - 1;
        return (
          <span key={`${v.testo}-${i}`} className="inline-flex items-center gap-1 min-w-0">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-slate-300 flex-shrink-0" />}
            {v.a && !ultima ? (
              <Link to={v.a} className="text-orange-600 hover:underline truncate max-w-[16rem]">
                {v.testo}
              </Link>
            ) : (
              <span className={`truncate max-w-[18rem] ${ultima ? "text-slate-500" : "text-slate-600"}`}>
                {v.testo}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
